// extracted by mini-css-extract-plugin
export default {"relatedGuides":"RelatedGuides_relatedGuides__4KF-7","relatedGuidesWrapper":"RelatedGuides_relatedGuidesWrapper__CtpF8","guidesTitle":"RelatedGuides_guidesTitle__0Ut6W"};